import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-curtain-straight',
  templateUrl: './curtain-straight.component.html',
  styleUrls: ['./curtain-straight.component.scss']
})
export class CurtainStraightComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
